/**
* @Author: zachalam
* @Date:   2017-01-19T17:12:00-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-19T17:12:59-08:00
*/

import React, { Component } from 'react';
import TripDetails from '../components/pages/Trips/TripDetails';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';
import { refreshTripLikes, favTripUserInStore, refreshTrip, joinTrip, joinTripDetail, cancelTrip } from '../actions/tripActions';
import { favToggle } from '../actions/favActions';

class TripDetailsContainer extends Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    // check to see if user owns this trip.
    let tripID = parseInt(this.props.params.tripID);
    this.props.refreshTrip(tripID);
    this.props.refreshTripLikes(tripID);
  }


  render() {
    return (
      <TripDetails {...this.props} />
    );
  }
}

const mapStateToProps = (state) => {
  console.log(state);
  return {
    profile: state.profile,
    trips: state.profile.trip.data,
    likes: state.trip.likes,
    moreExists: Boolean(state.meta.triplikes_current_page < state.meta.triplikes_total_pages),
    trip: state.trip
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    refreshTrip: (tripID) => {
      dispatch(refreshTrip(tripID))
    },
    refreshTripLikes: (tripID) => {
      dispatch(refreshTripLikes(tripID,true));
    },
    joinTrip: (tripId) => {
      dispatch(joinTrip(tripId)),
      dispatch(joinTripDetail())
    },
    toggle: (username,favKey) => {
      // notify store
      dispatch(favTripUserInStore(favKey));
      // notify api
      dispatch(favToggle(username));
    },
    loadMore(tripID) {
      dispatch(refreshTripLikes(tripID,false));
    },
    cancelTrip: (tripId,tripKey,reason) => {
      //console.log(tripId);
      dispatch(cancelTrip(tripId,tripKey,reason));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TripDetailsContainer);



// WEBPACK FOOTER //
// ./src/containers/TripDetailsContainer.jsx